/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var MediaUiAPlayIcon16Regular = forwardRef('MediaUiAPlayIcon16Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3.25 3.18a1.4 1.4 0 0 1 2.148-1.184l7.632 4.82a1.4 1.4 0 0 1 0 2.368l-7.632 4.82a1.4 1.4 0 0 1-2.148-1.183V3.179Zm1.5.18v9.28L12.095 8 4.75 3.36Z" })));
});
